/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Sitesettings_Remove_N1Inputs */

const vi_sitesettings_remove_n1 = /** @type {(inputs: Sitesettings_Remove_N1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá mục ${i?.n}`)
};

/**

* @param {Sitesettings_Remove_N1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_remove_n1 = /** @type {((inputs: Sitesettings_Remove_N1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Remove_N1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_remove_n1(inputs)
});
export { sitesettings_remove_n1 as "siteSettings_remove_n" }